<ng-template *ngIf="tab.labelTemplate" [ngTemplateOutlet]="tab.labelTemplate"></ng-template>
<ng-container *ngIf="tab.label && !tab.labelTemplate">{{ tab.label }}</ng-container>
